import clsx from "clsx";

import { candidacyStatusToBackgroundColor } from "@/lib/constants";
import { CandidacyStatus } from "@/types";

export const JobPipelineKanbanColumnHeader = ({
  count,
  headerText,
  keyField,
}: {
  count: number;
  headerText: string;
  keyField: CandidacyStatus;
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <div
          className={clsx(
            "h-3 w-3 rounded-full",
            candidacyStatusToBackgroundColor[keyField],
          )}
        />
        <p className="text-base font-medium text-slate-800">{headerText}</p>
      </div>
      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-slate-400">
        <p className="text-sm font-semibold text-slate-800">{count}</p>
      </div>
    </div>
  );
};
